import { Button, Stack } from '@mui/material';
import React from 'react';
import ProductsFormModal from './ProductsFormModal';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PRODUCT } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';
import BulkUploadButton from '../../bulkUpload/components/BulkUploadButton';

function ProductsListPageActions() {
  const [open, setOpen] = React.useState(false);
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const { products: p } = useTranslatedMessages();
  const addNewLabel = p.list_actions?.add_new ?? '+ Add New';
  const canCreate = hasEInvoicePermission(CREATE_PRODUCT);

  const handleClick = () => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Stack direction="row" spacing={1}>
        <BulkUploadButton
          category="PRODUCT"
          requiredPermission={CREATE_PRODUCT}
          redirectAfterSubmit="/sales/bulk-upload"
        />
        <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
          <Button
            data-testid="add-product-button"
            key="add-new-product"
            variant="contained"
            color="primary"
            onClick={handleClick}
            disabled={!canCreate}
          >
            {addNewLabel}
          </Button>
        </PermissionDeniedWrapper>
      </Stack>
      <SubscriptionModal />
      <ProductsFormModal open={open} handleClose={handleClose} />
    </>
  );
}

export default ProductsListPageActions;
